export const FETCH_ADSETS = 'adsets/FETCH_ADSETS'
export const SET_ADSET = 'adsets/SET_ADSET'
export const CLEAR_ADSETS_STATE = 'adsets/CLEAR_ADSETS_STATE'
